export function auth(roles, { ctx, to, from, router, next }) {
    const auth = ctx.$auth

    if (typeof roles === 'string') {
        roles = roles.split(',').map((i) => i.toUpperCase())
    }

    // no auth
    if (!auth.user) {
        if (to.name === 'SignIn' || to.name === 'signup') return next()
        return next('/signin')
    }

    if (to.name === 'SignIn' || to.name === 'signup') return next('/')

    return next()
}

export function saveParams({ to, from, router, next }) {
    if (!to.params) return router.push('/').catch(() => {})
    return next()
}

export function saveQuery({ to, from, router, next }) {
    if (!to.query) return router.push('/').catch(() => {})
    return next()
}

//

export function nextFactory(context, middlewares, index) {
    const subSequentMiddleware = middlewares[index]
    if (!subSequentMiddleware) return context.next

    return (...parameters) => {
        context.next(...parameters)
        const nextMiddleware = nextFactory(context, middlewares, index + 1)
        subSequentMiddleware({ ...context, next: nextMiddleware })
    }
}
